// extracted by mini-css-extract-plugin
module.exports = {"Clock":"Clock_Clock__K2GKF"};